var map = {
	"./info-sharing-center-de.html": 1039,
	"./info-sharing-center-en.html": 1040,
	"./info-sharing-center-es.html": 1041,
	"./info-sharing-center-fr.html": 1042,
	"./info-sharing-center-ja.html": 1043,
	"./info-sharing-center-pt.html": 1044,
	"./info-sharing-center-zh.html": 1045
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1038;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 1038
// module chunks = 0